import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  metaTitle: any;
  keywords: any;
  description: any;
  public pageH1Tag = new BehaviorSubject(false);
  seoEnabled: any;

  constructor(private titleService: Title, private metaService: Meta) { }

  setMetatitle(metaTitle): void {
    this.titleService.setTitle(metaTitle);
  }

  setMetaTags(metaData): void {
    this.metaService.addTags(metaData);
  }

  updateMetaTags(metaData): void {
    this.metaService.updateTag({ property: metaData.name, content: metaData.content });
  }

  defaultMetaTag(): void {
    if (this.metaTitle) {
      this.titleService.setTitle(this.metaTitle);
    }
    if (this.keywords) {
      this.metaService.updateTag({ property: 'og:keywords', content: this.keywords });
    }
    if (this.description) {
      this.metaService.updateTag({ property: 'og:description', content: this.description });
    }
  }

}
